
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-qr-code-generator",
      function () {
        return require("private-next-pages/whatsapp-qr-code-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-qr-code-generator"])
      });
    }
  